module.exports = __webpack_public_path__ + "35b5a482e4c47fdd138c7cd6c02137e1.pdf";